// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"a395f5d6","882":"f5a19476"}[chunkId] + ".chunk.js";
};